export var DocsBlockItemPropertyType;
(function (DocsBlockItemPropertyType) {
    /** Rich text property used for core rich text blocks */
    DocsBlockItemPropertyType["richText"] = "RichText";
    /** Rich text property allows user to input multiple paragraphs of rich text (with additional attributes like bold, links etc.) */
    DocsBlockItemPropertyType["multiRichText"] = "MultiRichText";
    /** Text property allows user to input plain text */
    DocsBlockItemPropertyType["text"] = "Text";
    /** Rich text property to be used in custom blocks to input rich text (with additional attributes like bold, links etc.) */
    DocsBlockItemPropertyType["richTextEditor"] = "RichTextEditor";
    /** Boolean property allows user to input true/false value */
    DocsBlockItemPropertyType["boolean"] = "Boolean";
    /** Number property allows user to input number */
    DocsBlockItemPropertyType["number"] = "Number";
    /** Single-select property allows user to select one of the options */
    DocsBlockItemPropertyType["singleSelect"] = "SingleSelect";
    /** Multi-select property allows user to select multiple of the options */
    DocsBlockItemPropertyType["multiSelect"] = "MultiSelect";
    /** Image property allows user to select or upload image */
    DocsBlockItemPropertyType["image"] = "Image";
    /** Token type allows data access to the tokens defined in design system */
    DocsBlockItemPropertyType["token"] = "Token";
    /** Token type allows selection of type(s) such as color, typography etc., for further use such as filtering */
    DocsBlockItemPropertyType["tokenType"] = "TokenType";
    /** Token property allows selection of custom token properties (columns) */
    DocsBlockItemPropertyType["tokenProperty"] = "TokenProperty";
    /** Component type allows data access to the components defined in design system */
    DocsBlockItemPropertyType["component"] = "Component";
    /** Component property allows selection of custom component properties (columns) */
    DocsBlockItemPropertyType["componentProperty"] = "ComponentProperty";
    /** Asset type allows data access to the assets defined in design system */
    DocsBlockItemPropertyType["asset"] = "Asset";
    /** Asset property allows selection of custom asset properties (columns) */
    DocsBlockItemPropertyType["assetProperty"] = "AssetProperty";
    /** Page type allows data access to the pages defined in design system */
    // page = "Page",
    /** Page property allows selection of custom page properties (columns) */
    // pageProperty = "PageProperty",
    /** Embed property allows user to input page to be embedded via URL */
    DocsBlockItemPropertyType["embedURL"] = "EmbedURL";
    /** URL property allows user to input a valid URL */
    DocsBlockItemPropertyType["url"] = "URL";
    /** Embed property allows user to input page to be embedded via iframe */
    // embedFrame = "EmbedFrame",
    /** Markdown property allows user to add markdown to render */
    DocsBlockItemPropertyType["markdown"] = "Markdown";
    /** Code property allows user to add code to render */
    DocsBlockItemPropertyType["code"] = "Code";
    /** Sandbox property allows user to add code sandbox to render live component */
    DocsBlockItemPropertyType["codeSandbox"] = "CodeSandbox";
    /** Table property allows user to add table to render */
    DocsBlockItemPropertyType["table"] = "Table";
    /** Divider property that puts visual divider into the block. It has no user input */
    DocsBlockItemPropertyType["divider"] = "Divider";
    /** Storybook property allows user to add Storybook story to render */
    DocsBlockItemPropertyType["storybook"] = "Storybook";
    /** Color property allows users to select color for further use */
    DocsBlockItemPropertyType["color"] = "Color";
    /** Figma node property (frames, sections, etc.) */
    DocsBlockItemPropertyType["figmaNode"] = "FigmaNode";
    /** Figma component property (Figma components, variants, properties, etc.) */
    DocsBlockItemPropertyType["figmaComponent"] = "FigmaComponent";
    /** File property allows user to add file to download */
    DocsBlockItemPropertyType["file"] = "File";
})(DocsBlockItemPropertyType || (DocsBlockItemPropertyType = {}));
